(function () {
  var body = document.body;
  var menu = document.querySelector('[data-mobile-menu]');
  var menuButtons = document.querySelectorAll('[data-menu-toggle]');
  var cartToast = document.querySelector('[data-cart-toast]');
  var cartToastMessage = document.querySelector('[data-cart-toast-message]');
  var cartToastClose = document.querySelector('[data-cart-toast-close]');
  var locationButton = document.querySelector('[data-location-button]');
  var locationDialog = document.querySelector('[data-location-dialog]');
  var locationDisplay = document.querySelector('[data-location-display]');
  var regularStorefront = document.querySelector('[data-regular-storefront]');
  var bulkStorefront = document.querySelector('[data-bulk-storefront]');
  var toastTimer;

  function setPurchasingMode(isBulk) {
    if (regularStorefront) regularStorefront.hidden = isBulk;
    if (bulkStorefront) bulkStorefront.hidden = !isBulk;
    body.classList.toggle('mode-bulk', isBulk);
    document.querySelectorAll('[data-mode-status-regular], [data-mode-action-regular], [data-mode-toggle-regular]').forEach(function (item) {
      item.hidden = isBulk;
    });
    document.querySelectorAll('[data-mode-status-bulk], [data-mode-action-bulk], [data-mode-toggle-bulk]').forEach(function (item) {
      item.hidden = !isBulk;
    });
  }

  setPurchasingMode(new URLSearchParams(window.location.search).get('mode') === 'bulk');

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (item) {
      item.textContent = count;
    });
  }

  function openCartToast(message) {
    if (!cartToast) return;
    if (cartToastMessage) cartToastMessage.textContent = message || 'Basket updated.';
    cartToast.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      cartToast.hidden = true;
    }, 6000);
  }

  function closeCartToast() {
    if (cartToast) cartToast.hidden = true;
    window.clearTimeout(toastTimer);
  }

  if (cartToastClose) cartToastClose.addEventListener('click', closeCartToast);

  function closeLocationDialog() {
    if (!locationDialog) return;
    locationDialog.hidden = true;
    if (locationButton) locationButton.setAttribute('aria-expanded', 'false');
    body.classList.remove('location-open');
  }

  function openLocationDialog() {
    if (!locationDialog) return;
    locationDialog.hidden = false;
    if (locationButton) locationButton.setAttribute('aria-expanded', 'true');
    body.classList.add('location-open');
  }

  if (locationButton) {
    locationButton.setAttribute('aria-expanded', 'false');
    locationButton.addEventListener('click', openLocationDialog);
  }
  document.querySelectorAll('[data-location-close]').forEach(function (button) {
    button.addEventListener('click', closeLocationDialog);
  });
  document.querySelectorAll('[data-location-choice]').forEach(function (choice) {
    choice.addEventListener('click', function () {
      var value = choice.getAttribute('data-location-choice');
      if (!value) return;
      try { window.localStorage.setItem('freshcart-location', value); } catch (error) {}
      if (locationDisplay) locationDisplay.textContent = value;
      document.querySelectorAll('[data-location-choice]').forEach(function (item) {
        item.classList.toggle('is-selected', item === choice);
      });
      closeLocationDialog();
    });
  });
  document.querySelectorAll('[data-saved-address]').forEach(function (addressButton) {
    addressButton.addEventListener('click', function () {
      var savedAddress = addressButton.getAttribute('data-saved-address');
      if (!savedAddress) return;
      try { window.localStorage.setItem('freshcart-location', savedAddress); } catch (error) {}
      if (locationDisplay) locationDisplay.textContent = savedAddress;
      openCartToast('Delivery location selected.');
    });
  });
  try {
    var savedLocation = window.localStorage.getItem('freshcart-location');
    if (savedLocation && locationDisplay) locationDisplay.textContent = savedLocation;
  } catch (error) {}
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeLocationDialog();
      closeCartToast();
    }
  });

  menuButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (!menu) return;
      var isOpen = !menu.hasAttribute('hidden');
      if (isOpen) {
        menu.setAttribute('hidden', '');
      } else {
        menu.removeAttribute('hidden');
      }
      menuButtons.forEach(function (item) {
        item.setAttribute('aria-expanded', String(!isOpen));
      });
      body.classList.toggle('menu-open', !isOpen);
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('.quick-add').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('button');
      if (button) button.disabled = true;

      fetch(window.theme.cartAddUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not add this product');
          return response.json();
        })
        .then(function (item) {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
              if (!response.ok) throw new Error('Could not refresh basket');
              return response.json();
            })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              openCartToast(item.product_title + ' was added.');
            });
        })
        .catch(function () {
          openCartToast('This product could not be added. Please try again.');
        })
        .finally(function () {
          if (button) {
            button.disabled = false;
            button.classList.add('is-added');
            window.setTimeout(function () { button.classList.remove('is-added'); }, 900);
          }
        });
    });
  });

  document.querySelectorAll('[data-shipping-calculator]').forEach(function (calculator) {
    var submit = calculator.querySelector('[data-shipping-submit]');
    var status = calculator.querySelector('[data-shipping-status]');
    var rates = calculator.querySelector('[data-shipping-rates]');
    if (!submit || !status || !rates) return;

    function setShippingStatus(message) {
      status.textContent = message;
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character];
      });
    }

    function formatShippingPrice(value) {
      var amount = Number(value);
      if (!Number.isFinite(amount)) return value || 'Calculated at checkout';
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: window.theme.currency || 'PKR'
        }).format(amount);
      } catch (error) {
        return (window.theme.currency || 'PKR') + ' ' + amount.toFixed(2);
      }
    }

    function getShippingRates(attempt) {
      return fetch(window.theme.shippingRatesUrl, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (response.status === 202 && attempt < 8) {
            return new Promise(function (resolve) {
              window.setTimeout(function () { resolve(getShippingRates(attempt + 1)); }, 500);
            });
          }
          if (!response.ok) throw new Error('Shipping rates are unavailable');
          return response.json();
        });
    }

    submit.addEventListener('click', function () {
      var query = new URLSearchParams();
      query.set('shipping_address[country]', calculator.querySelector('[data-shipping-country]').value);
      query.set('shipping_address[city]', calculator.querySelector('[data-shipping-city]').value);
      query.set('shipping_address[zip]', calculator.querySelector('[data-shipping-zip]').value);
      submit.disabled = true;
      rates.innerHTML = '';
      setShippingStatus('Calculating delivery rates…');

      fetch(window.theme.shippingPrepareUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: query.toString()
      })
        .then(function (response) {
          if (!response.ok && response.status !== 202) throw new Error('Shipping rates are unavailable');
          return getShippingRates(0);
        })
        .then(function (data) {
          var shippingRates = data.shipping_rates || [];
          if (!shippingRates.length) {
            setShippingStatus('No delivery rate was found for this address.');
            return;
          }
          setShippingStatus('Available delivery options');
          rates.innerHTML = shippingRates.map(function (rate) {
            var title = escapeHtml(rate.name || rate.title || 'Delivery');
            return '<div class="shipping-rate"><span>' + title + '</span><strong>' + escapeHtml(formatShippingPrice(rate.price)) + '</strong></div>';
          }).join('');
        })
        .catch(function () {
          setShippingStatus('Shipping will be calculated securely at checkout for this address.');
        })
        .finally(function () {
          submit.disabled = false;
        });
    });
  });
})();